/**
 * Helpers for creating Notes instance
 */

import type { IBaseCustomer } from "../../BaseCustomerFactory";
import type Note from "le-coffre-resources/dist/Customer/Note";
import type { QueryPayload } from "../../../../types";
import {
	createGetByUidMethod,
	createGetByCustomerAndFolderMethod,
	createPostMethod,
	createPutMethod,
	createDeleteMethod,
} from "./notesMethodsHelpers";

export interface NotesInstance {
	getByUid(uid: string, q?: QueryPayload): Promise<Note>;
	getByCustomerAndFolder(customerUid: string, folderUid: string): Promise<Note[]>;
	post(note: Partial<Note>): Promise<Note>;
	put(uid: string, note: Partial<Note>): Promise<Note>;
	delete(uid: string): Promise<Note>;
}

/**
 * Create Notes instance with all methods
 */
export function createNotesInstance(baseCustomer: IBaseCustomer): NotesInstance {
	const baseUrl = baseCustomer.namespaceUrl.concat("/notes");

	return {
		getByUid: createGetByUidMethod(baseCustomer, baseUrl),
		getByCustomerAndFolder: createGetByCustomerAndFolderMethod(baseCustomer, baseUrl),
		post: createPostMethod(baseCustomer, baseUrl),
		put: createPutMethod(baseCustomer, baseUrl),
		delete: createDeleteMethod(baseCustomer, baseUrl),
	};
}
